import React from "react";
import {
  Button,
  Text,
  Modal,
  ModalContent,
  ModalFooterButtons,
} from "@reside/ui";

type Props = Readonly<{
  residentName: string;
  isOpen: boolean;
  isLoading: boolean;
  onRequestClose: () => void;
  onArchive: () => void;
  workflowType: string;
}>;

export const ArchiveModal = ({
  residentName,
  isOpen,
  isLoading,
  onArchive,
  onRequestClose,
  workflowType,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    title={`Archive ${workflowType || "admission"} for ${residentName}`}
  >
    {({closeModal}) => (
      <>
        <ModalContent>
          <Text as="p">
            Do you really wish to archive this {workflowType || "admission"}?
            The changes are irreversible.
          </Text>
        </ModalContent>
        <ModalFooterButtons>
          <Button color="primary" outline onClick={closeModal}>
            Cancel
          </Button>
          <Button color="danger" disabled={isLoading} onClick={onArchive}>
            {isLoading ? "Archiving..." : "Archive"}
          </Button>
        </ModalFooterButtons>
      </>
    )}
  </Modal>
);
